import React, { useState } from 'react';
import './whatIsRugby.css';
import whatIsRugbyImg from '../../assets/whatIsRugby.jpg'; // Example image
import rugbyFieldImg from '../../assets/rugbyField.jpg'; // Example image of rugby field

const WhatIsRugby = () => {
    const [activeSection, setActiveSection] = useState(null);

    const toggleSection = (section) => {
        setActiveSection(activeSection === section ? null : section);
    };

    return (
        <section id="whatIsRugby">
            <h1 className="whatIsRugbyTitle">What is Rugby?</h1>
            
            <div className="whatIsRugbyContent">
                {/* Rugby Basics Section */}
                <div className="whatIsRugbyItem">
                    <img src={whatIsRugbyImg} alt="Rugby Introduction" className="whatIsRugbyImg" />
                    <div className="whatIsRugbyText">
                        <h2 onClick={() => toggleSection('basics')} className="interactiveHeading">
                            How is Rugby Played? {activeSection === 'basics' ? '▲' : '▼'}
                        </h2>
                        {activeSection === 'basics' && (
                            <p>
                                Rugby is played with two teams of 15 players on a rectangular field. The objective is to score points by 
                                carrying, passing, or kicking the ball into the opposing team's goal area or through their goalposts. 
                                Players can pass the ball backward but not forward, and tackles are used to stop opponents.
                            </p>
                        )}
                    </div>
                </div>

                {/* Rugby Positions Section */}
                <div className="whatIsRugbyItem">
                    <img src={rugbyFieldImg} alt="Rugby Field" className="whatIsRugbyImg" />
                    <div className="whatIsRugbyText">
                        <h2 onClick={() => toggleSection('positions')} className="interactiveHeading">
                            Player Positions & Field Layout {activeSection === 'positions' ? '▲' : '▼'}
                        </h2>
                        {activeSection === 'positions' && (
                            <p>
                                Rugby positions are divided into forwards and backs. Forwards focus on physical plays like scrums and lineouts, 
                                while backs specialize in speed and precision for scoring tries. The field includes the try line, goalposts, 
                                and specific zones like the scrum and lineout areas.
                            </p>
                        )}
                    </div>
                </div>

                            </div>
                     
        </section>
    );
};

export default WhatIsRugby;
